





























import Vue from 'vue';
import PlaylistTeacherThumbnail from '@/web/components/playlists/PlaylistTeacherThumbnail';

export default Vue.extend({
  name: 'PlaylistsPanelStudentItemCard',
  props: {
    playlist: {
      type: Object as () => PlaylistResponse,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hover: false,
    };
  },
  components: {
    PlaylistTeacherThumbnail,
  },
});
